enum AddOnType {
  APP_EXTENSION = "app_extension", // hosted on the provider's site
  BROWSER_EXTENSION = "browser_extension", // hosted on chrome web store, firefox addons, etc
  CUSTOM_EXTENSION = "custom_extension", // hosted om our site or third party
  THEME = "theme", // just a theme
  ASSETS = "assets", // collection of assets
  OTHER = "other", // other
	SERVICE = "service", // service
}

// eslint-disable-next-line no-redeclare
namespace AddOnType {
  export const names = {
    [AddOnType.APP_EXTENSION]: "Extension",
    [AddOnType.BROWSER_EXTENSION]: "Browser Extension",
    [AddOnType.CUSTOM_EXTENSION]: "Custom Extension",
    [AddOnType.THEME]: "Theme",
    [AddOnType.ASSETS]: "Assets",
    [AddOnType.OTHER]: "Other",
		[AddOnType.SERVICE]: "Service",
  } as any;

  export const display = (type: AddOnType) => names[type];

  export const defaultValue = AddOnType.APP_EXTENSION;
}

export { AddOnType };
